"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "alzate-brianza": {
    "8a010362": [{
      "hkey": "13b25ac0",
      "slug": "alzate-brianza",
      "name": "Alzate Brianza",
      "primary": true,
      "skipSearch": false
    }],
    "carbusate": [{
      "hkey": "13b25ac0",
      "slug": "alzate-brianza",
      "name": "Alzate Brianza",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "1749adf7": [{
      "hkey": "69f3211f",
      "slug": "fabbrica-durini-mirovano",
      "name": "Fabbrica Durini-Mirovano",
      "primary": true,
      "skipSearch": false
    }],
    "fabbrica-durini": [{
      "hkey": "69f3211f",
      "slug": "fabbrica-durini-mirovano",
      "name": "Fabbrica Durini-Mirovano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "bf207b96": [{
      "hkey": "69f3211f",
      "slug": "fabbrica-durini-mirovano",
      "name": "Fabbrica Durini-Mirovano",
      "primary": true,
      "skipSearch": false
    }],
    "mirovano": [{
      "hkey": "69f3211f",
      "slug": "fabbrica-durini-mirovano",
      "name": "Fabbrica Durini-Mirovano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "alzate-brianza"
    }]
  }
};
exports["default"] = _default;